// extracted by mini-css-extract-plugin
module.exports = {"custom_input":"style_custom_input__rLdu6","input_wrapper":"style_input_wrapper__10xA8"};